import React, { useState } from "react"
import { Col, Row, Card, Tag } from "antd"
import { Link, Route, RouteComponentProps, useHistory } from "react-router-dom"
import EmailSvg from "../svgs/EmailSvg"
import { channelsDef } from "../channels.def"
import ChannelCard from "../ChannelCard"
import { isAldeia } from "hooks/useAldeia"
import AddEmail from "./AddEmail"
import AddEmailOutlook, { EmailOutlookLogoBase64 } from "./AddEmailOutlook"

interface IChannelType {
  ComponentSVG?: any
  name?: string | React.ReactNode
  to?: string
  logoType?: "image"
  imgStyle?: any
  disabled?: boolean
  oficial?: boolean
  onClick?: Function
}

export const LinkButton = ({ children, ...props }: any) => <a {...props}>{children}</a>

function AddChannelEmail() {
  const emailDef = channelsDef.record["email"]

  // const channelsTypes: IChannelType[] = [
  //   {
  //     ComponentSVG: EmailSvg,
  //     name: "Por encaminhamento",
  //     to: "/settings/channels/new/email/forward",
  //   },
  //   {
  //     ComponentSVG: EmailSvg,
  //     name: "IMAP/SMTP",
  //     to: "/settings/channels/new/email/imap-smtp",
  //   },
  // ]

  return (
    <>
      <Row gutter={15} wrap={false} className="aldeia:grid grid-cols-[repeat(auto-fit,_minmax(160px,_200px))] aldeia:gap-2 aldeia:px-2">
        <ChannelCard
          to={"/settings/channels/new/email/forward"}
          icon={isAldeia ? <div className="size-11">{emailDef?.icon}</div> : <EmailSvg />}
          name={"Por encaminhamento"}
          index={0}
        />
        <ChannelCard
          to={"/settings/channels/new/email/imap-smtp"}
          icon={isAldeia ? <div className="size-11">{emailDef?.icon}</div> : <EmailSvg />}
          name={"IMAP/SMTP"}
          index={2}
        />
        <ChannelCard
          to={"/settings/channels/new/email/outlook"}
          icon={isAldeia ? <div className="size-11">{<img src={EmailOutlookLogoBase64} />}</div> : <img src={EmailOutlookLogoBase64} />}
          name={"Outlook"}
          index={2}
        />
      </Row>
      <Route path={`/settings/channels/new/email/forward`} render={() => <AddEmail />} />
      <Route path={`/settings/channels/new/email/imap-smtp`} render={() => <AddEmail />} />
      <Route path={`/settings/channels/new/email/outlook`} render={() => <AddEmailOutlook />} />
    </>
  )
}

export default AddChannelEmail
